import { createHereTileUrl, HERE_ATTRIBUTION } from '@klareospace/pharos-lib-web-utils';

import { env } from './env';

export { HERE_ATTRIBUTION };
export const HERE_TILE_URL = createHereTileUrl(env.hereApiKey);
